import React, { useEffect, useState } from 'react'
import { useMergeState } from '../../../irmlib/src/hooks'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { setBusy, clearBusy } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
import { Autocomplete, TextField } from '@mui/material'
import { getUser } from '../../../redux/global'
import PropTypes from 'prop-types'
import { ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import LockedFieds from './Lockedfieds'

const Buttons = (props) => (
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>
)

Buttons.propTypes = {
  arrRefs: PropTypes.array,
}

const VerticalDivider = () => <YDivider height='15px' />

const initialSate = {
  assetTypes: [],
  templateField: [],
  templateTypes: [],
  selectedCustomerID: [],
  selectedAssetTypes: [],
  selectedTemplateTypes: [],
  customerId: [],
  templateFieldsOneil: [],
  wmsInstance: []
}

const ManageLocked = (props) => {
  const [state, setState] = useMergeState(initialSate)
  const [selectedCustomerId, setSelectedCustomerId] = React.useState(null)
  // eslint-disable-next-line
  const { t } = useTranslation()

  useEffect(() => {
    getCustomerID()
    getTemplateFields()
  }, [])

  const getTemplateFields = async () => {
    setBusy()
    const [, , , , , , templateFields, , OneilField] = await localGdeTransactions.getGdeConfig()
    const templateName = 'oneilStandardNewBox'
    const templateDataRaw = await localGdeTransactions.getTemplateById(templateName)
    const templateData = templateDataRaw.data()
    const templateFieldsOneil = templateData?.templateFields
    setState({
      templateField: templateFields,
      templateFieldsOneil: templateFieldsOneil, 
      OneilField: OneilField,
    })
    clearBusy()
  }

  const [selectedWmsInstance, setSelectedWmsInstance] = useState('')

  useEffect(() => {
    const { workerId } = getUser()
    getWmsInstance(workerId)
  }, [])

  const getCustomerID = async (wmsCodeSelected) => {
    setBusy()
    const collection = await localGdeTransactions.getCustomerID()
    let CustomerId = []
    collection.forEach((doc) => {
      const accountLevel1 = doc.data().accountLevel1
      const wmsCode = doc.data().wmsCode
      if (accountLevel1 && accountLevel1.trim() !== '' && wmsCodeSelected === wmsCode) {
        CustomerId.push({
          value: accountLevel1.trim(),
          label: accountLevel1.trim(),
        })
      }
    })
    CustomerId = Array.from(
      new Set(CustomerId.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    setState({ customerId: CustomerId })
    clearBusy()
  }

  const getWmsInstance = async (workerId) => {
    setBusy()
    const workerDetailsGde = await localGdeTransactions.getWorkerRoleGde(workerId)
    const doc = await localGdeTransactions.getSkpInstance(workerDetailsGde?.gdeCountryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setState({ wmsRegion: skpInstance })
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP', label: 'SKP'
        })
      }
    }
    
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({ value: key, label: key }))
      setState({ wmsRegions: instances })
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL', label: 'ONEIL'
        })
      }
    }

    setState({
      wmsInstance: wmsList
    })
    clearBusy()
  }

  const onChangeWms = (value) => {
    setSelectedWmsInstance(value)
    getCustomerID(value)
  }

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.smartCatalogLockFieldManagement'
    >
      <FlexByRow style={{ width: '80%' }}>
        <HalfScreen>
          <FlexByRow style={{ width: '80%' }}>
            {/* WMS Instance Autocomplete with specific width */}
            <Autocomplete
              sx={{ m: 1, width: '190px' }}
              size="small"
              options={state.wmsInstance}
              getOptionLabel={(option) => option.label}
              onChange={(e, value) => onChangeWms(value?.value)}
              renderInput={(params) => <TextField {...params} label={t('Search.wms')} />}
            />

            {/* Customer ID Autocomplete with specific width */}
            <div style={!selectedWmsInstance ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
              <Autocomplete
                sx={{ m: 1, width: '190px' }}
                size="small"
                options={state.customerId}
                getOptionLabel={(option) => option.label}
                onChange={(e, value) => setSelectedCustomerId(value?.value)}
                renderInput={(params) => <TextField {...params} label={t('templates.customerId')} variant="outlined" />}
                noTranslate
              />
            </div>
          </FlexByRow>
        </HalfScreen>
      </FlexByRow>

      <VerticalDivider />

      <div style={!(selectedWmsInstance && selectedCustomerId) ? { pointerEvents: 'none', opacity: 0.5 } : {}}>
        <LockedFieds
          customerId={selectedCustomerId}
          templateFields={state.templateField}
          templateFieldsOneil={state.templateFieldsOneil}
          OneilField={state.OneilField}
          selectedWmsInstance={selectedWmsInstance}
        />

      </div>
    </MainRouteSubRoutePage>
  )
}

export default ManageLocked